import { Admin } from './Admin'

const Extend = { Admin }
export default Extend
